// Theme: terminal
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'terminal',
  name: 'TERMINAL',
  tagline: 'TERMINAL',
  description: 'Terminal hacker classico. Verde fosforoso sobre preto absoluto.',
  category: 'system-core',
  tier: 'common',
  basePrice: 0,
  swatches: ['#0A0F0A', '#33FF00', '#0F2A0F', '#CCFF99'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '0px',
      '--shadow-card': 'none',
      '--shadow-card-active': '0 0 0 1px color-mix(in srgb, var(--primary) 24%, transparent)'
    },
    shellClasses: 'font-sans theme-terminal'
  },
  colorVars: {
    '--accent': '#33FF00',
    '--accent-foreground': '#0A0F0A',
    '--background': '#0A0F0A',
    '--border': '#1A6A1A',
    '--card': '#0F2A0F',
    '--card-border-active': 'rgba(51, 255, 0, 0.05)',
    '--card-completed': '#143014',
    '--card-foreground': '#CCFF99',
    '--card-glow': 'rgba(51, 255, 0, 0.05)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A0F0A',
    '--foreground': '#CCFF99',
    '--hold-fill': '#33FF00',
    '--input': '#0F2A0F',
    '--modal-bg': '#0A0F0A',
    '--modal-border': '#1A6A1A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': 'none',
    '--muted': '#1A6A1A',
    '--muted-foreground': '#8ACC66',
    '--nav-active': '#33FF00',
    '--nav-bg': '#0A0F0A',
    '--popover': '#0F2A0F',
    '--popover-foreground': '#CCFF99',
    '--primary': '#33FF00',
    '--primary-foreground': '#0A0F0A',
    '--ring': '#33FF00',
    '--secondary': '#1A6A1A',
    '--secondary-foreground': '#CCFF99',
    '--streak': '#33FF00',
    '--success': '#22c55e',
    '--success-foreground': '#0A0F0A',
    '--xp': '#33FF00',
    '--xp-bg': '#0F2A0F'
  },
  resolvedVars: {
    '--accent': '#33FF00',
    '--accent-foreground': '#0A0F0A',
    '--accent-foreground-hsl': '120 20% 5%',
    '--accent-foreground-oklch': 'from #0A0F0A l c h',
    '--accent-hsl': '108 100% 50%',
    '--accent-oklch': 'from #33FF00 l c h',
    '--background': '#0A0F0A',
    '--background-hsl': '120 20% 5%',
    '--background-oklch': 'from #0A0F0A l c h',
    '--border': '#1A6A1A',
    '--border-hsl': '120 61% 26%',
    '--border-oklch': 'from #1A6A1A l c h',
    '--border-w': '1px',
    '--card': '#0F2A0F',
    '--card-border-active': 'rgba(51, 255, 0, 0.05)',
    '--card-completed': '#143014',
    '--card-completed-hsl': '120 41% 13%',
    '--card-completed-oklch': 'from #143014 l c h',
    '--card-foreground': '#CCFF99',
    '--card-foreground-hsl': '90 100% 80%',
    '--card-foreground-oklch': 'from #CCFF99 l c h',
    '--card-glow': 'rgba(51, 255, 0, 0.05)',
    '--card-hsl': '120 47% 11%',
    '--card-oklch': 'from #0F2A0F l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A0F0A',
    '--destructive-foreground-hsl': '120 20% 5%',
    '--destructive-foreground-oklch': 'from #0A0F0A l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#CCFF99',
    '--foreground-hsl': '90 100% 80%',
    '--foreground-oklch': 'from #CCFF99 l c h',
    '--hold-fill': '#33FF00',
    '--hold-fill-hsl': '108 100% 50%',
    '--hold-fill-oklch': 'from #33FF00 l c h',
    '--input': '#0F2A0F',
    '--input-hsl': '120 47% 11%',
    '--input-oklch': 'from #0F2A0F l c h',
    '--modal-bg': '#0A0F0A',
    '--modal-bg-hsl': '120 20% 5%',
    '--modal-bg-oklch': 'from #0A0F0A l c h',
    '--modal-border': '#1A6A1A',
    '--modal-border-hsl': '120 61% 26%',
    '--modal-border-oklch': 'from #1A6A1A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': 'none',
    '--muted': '#1A6A1A',
    '--muted-foreground': '#8ACC66',
    '--muted-foreground-hsl': '99 50% 60%',
    '--muted-foreground-oklch': 'from #8ACC66 l c h',
    '--muted-hsl': '120 61% 26%',
    '--muted-oklch': 'from #1A6A1A l c h',
    '--nav-active': '#33FF00',
    '--nav-active-hsl': '108 100% 50%',
    '--nav-active-oklch': 'from #33FF00 l c h',
    '--nav-bg': '#0A0F0A',
    '--nav-bg-hsl': '120 20% 5%',
    '--nav-bg-oklch': 'from #0A0F0A l c h',
    '--popover': '#0F2A0F',
    '--popover-foreground': '#CCFF99',
    '--popover-foreground-hsl': '90 100% 80%',
    '--popover-foreground-oklch': 'from #CCFF99 l c h',
    '--popover-hsl': '120 47% 11%',
    '--popover-oklch': 'from #0F2A0F l c h',
    '--primary': '#33FF00',
    '--primary-foreground': '#0A0F0A',
    '--primary-foreground-hsl': '120 20% 5%',
    '--primary-foreground-oklch': 'from #0A0F0A l c h',
    '--primary-hsl': '108 100% 50%',
    '--primary-oklch': 'from #33FF00 l c h',
    '--radius': '0px',
    '--ring': '#33FF00',
    '--ring-hsl': '108 100% 50%',
    '--ring-oklch': 'from #33FF00 l c h',
    '--secondary': '#1A6A1A',
    '--secondary-foreground': '#CCFF99',
    '--secondary-foreground-hsl': '90 100% 80%',
    '--secondary-foreground-oklch': 'from #CCFF99 l c h',
    '--secondary-hsl': '120 61% 26%',
    '--secondary-oklch': 'from #1A6A1A l c h',
    '--shadow-card': 'none',
    '--shadow-card-active': '0 0 0 1px color-mix(in srgb, var(--primary) 24%, transparent)',
    '--streak': '#33FF00',
    '--streak-hsl': '108 100% 50%',
    '--streak-oklch': 'from #33FF00 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0A0F0A',
    '--success-foreground-hsl': '120 20% 5%',
    '--success-foreground-oklch': 'from #0A0F0A l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(108 100% 50% / 0.15)',
    '--xp': '#33FF00',
    '--xp-bg': '#0F2A0F',
    '--xp-bg-hsl': '120 47% 11%',
    '--xp-bg-oklch': 'from #0F2A0F l c h',
    '--xp-hsl': '108 100% 50%',
    '--xp-oklch': 'from #33FF00 l c h'
  }
}
